import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import $ from 'jquery';

import router from './router/pdd';
import store from './store';
import settings from './settings';
import ls from './services/ls';

import Pdd from './Pdd.vue';
import Loader from './components/pdd/Loader.vue';

import '@fortawesome/fontawesome-free/css/all.css';
import '../html/build-dev/css/main.min.css';

Vue.use(BootstrapVue);
Vue.component('Loader', Loader);

// provide jQuery
window.jQuery = $;
window.$ = $;

ls.initAppSettings();

Vue.config.productionTip = false;
Vue.prototype.$APP_URL = settings.APP_URL;
Vue.prototype.$appSettings = JSON.parse(ls.get('pdd-settings'));

new Vue({
  router,
  store,
  render: h => h(Pdd),
}).$mount('#test');
